/**
 * Is set
 * @description Shorthand function to check existence of the variable.
 * @param {Any} variable - The variable to check.
 * @return {Boolean} Whether passed variable exists/is set.
 */
const isset = variable => typeof variable !== 'undefined' && variable !== null;

export default isset;
